/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { DefaultApi } from '@sendspark/js-api-sdk';
import axios from 'axios';

export const getApiSdk = (() => {
  const apiBaseUrl = process.env.NEXT_PUBLIC_API_V2_URL;

  const onRequest = (configParam: any) => {
    const newParams = configParam;
    newParams.baseURL = configParam.baseURL
      ? `${configParam.baseURL}/api`
      : `${apiBaseUrl}/api`;
    newParams.headers.accept = 'application/json';
    newParams.withCredentials = true;
    newParams.headers[
      process.env.NEXT_PUBLIC_CUSTOM_USER_AGENT || 'X-Snd-Value'
    ] = process.env.NEXT_PUBLIC_CUSTOM_USER_AGENT_VALUE || 'Sendspark Share';

    return newParams;
  };

  const onRequestError = (error: any) => Promise.reject(error);

  const axiosConfig = {
    baseURL: apiBaseUrl,
    withCredentials: true,
    headers: {
      [process.env.NEXT_PUBLIC_CUSTOM_USER_AGENT || 'X-Snd-Value']:
        process.env.NEXT_PUBLIC_CUSTOM_USER_AGENT_VALUE || 'Sendspark Share',
    },
  };

  const axiosClient = axios.create(axiosConfig);

  axiosClient.interceptors.request.use(onRequest, onRequestError);

  // The SDK regen at 1.2.66-prod moved to axios ^1.8.0 while share still runs axios 0.21.1, so the
  // two `AxiosInstance` types no longer match structurally. The instance is only used for `.request()`,
  // which is identical in both majors, so the cast is safe and derives the expected type from the SDK
  // itself. Remove it when share upgrades axios (a behaviour change, not a build fix).
  return new DefaultApi({}, '', 
    axiosClient as unknown as ConstructorParameters<typeof DefaultApi>[2]
  );
})();

export default getApiSdk;
